<template>
  <p v-if="!table.rows.length" class="muted">{{ emptyText }}</p>
  <div v-else class="table-scroll">
    <table class="table">
      <thead>
        <tr>
          <th v-for="column in table.columns" :key="column.key" :class="column.align">{{ column.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in table.rows" :key="index">
          <td v-for="column in table.columns" :key="column.key" :class="classesOf(column, row)" :title="titleOf(column, row)">
            <span v-if="column.kind === 'badge' && row[column.key]" class="badge" :class="toneOf(column, row)">{{ row[column.key] }}</span>
            <template v-else>{{ text(column, row) }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {cell} from "@/administration/utils";

/**
 * Tableau décrit par un container : colonnes {key, label, align?, kind?, tones?, bad?} et lignes.
 * kind : text (défaut), number, percent, datetime, milliseconds, bytes, duration ou badge (tones : libellé → ok, warn ou bad).
 * bad : une valeur non nulle est affichée en rouge (échecs).
 */
export default {
  name: 'ActivityTable',
  props: {
    table: {type: Object, required: true},
    emptyText: {type: String, default: 'Aucune donnée pour le moment.'},
  },
  methods: {
    text(column, row) {
      return cell(column.kind, row[column.key]);
    },
    toneOf(column, row) {
      return column.tones?.[row[column.key]] ?? '';
    },
    classesOf(column, row) {
      return [column.align, {bad: column.bad && row[column.key] > 0, long: column.kind === 'text' || !column.kind}];
    },
    // Long texts (subject, error, path) are cut by the cell : the whole text is in the tooltip
    titleOf(column, row) {
      const value = row[column.key];
      return typeof value === 'string' && value.length > 40 && (column.kind === 'text' || !column.kind) ? value : undefined;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.muted
  margin 0
  font-size 13.5px
  color CTRL_TEXT_MUTED

.table-scroll
  overflow-x auto

.table
  width 100%
  border-collapse collapse
  font-size 13.5px

  th, td
    padding 9px 10px
    text-align left
    white-space nowrap

  th
    font-size 12.5px
    font-weight 600
    color CTRL_TEXT_MUTED
    border-bottom 1px solid #e5e5e5

  td
    color #3f3931
    border-bottom 1px solid #f1f3f8

    &.long
      max-width 320px
      overflow hidden
      text-overflow ellipsis

  .right
    text-align right

  .bad
    color CTRL_ERROR
    font-weight 600

.badge
  display inline-block
  padding 1px 10px
  font-size 12px
  font-weight 700
  border 1px solid
  border-radius 20px
  color CTRL_TEXT_MUTED
  background CTRL_BG
  border-color CTRL_BORDER

  &.ok
    color #1f6b3a
    background #e8f6ee
    border-color #bfe3cd

  &.warn
    color #8a5a00
    background #fff6e0
    border-color #f0d9a3

  &.bad
    color CTRL_ERROR
    background CTRL_ERROR_BG
    border-color #f3c6cd
</style>
